import { Component, Input } from '@angular/core';
import { DUMMY_DONUT_GRAPH_OPTIONS } from 'src/app/shared/data/data';

@Component({
  selector: 'app-general-time-circle',
  templateUrl: './general-time-circle.component.html',
  styleUrls: ['./general-time-circle.component.scss'],
})
export class GeneralTimeCircleComponent {
  @Input()
  timeNumber?: number = 0;

  @Input()
  timeText?: string = 'CHALLENGES.minutes';

  @Input()
  title: string;

  @Input()
  color: string;

  optionsGraph: any = DUMMY_DONUT_GRAPH_OPTIONS;
}
